"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customEvent = exports.stop = exports.start = exports.init = void 0;
const VERSION_PLACEHOLDER = '{version}';
const SDK_URL = `https://www.saola.ai/sdk/saola.${VERSION_PLACEHOLDER}.js`;
const win = window;
let initialized = false;
const init = (accountToken, version = 'latest', customOptions = {}) => {
    if (initialized)
        return;
    setParams(accountToken, customOptions);
    injectSDK(version);
    initialized = true;
};
exports.init = init;
const start = () => {
    if (!win.Saola || !win.Saola.start)
        return;
    win.Saola.start();
};
exports.start = start;
const stop = () => {
    if (!win.Saola || !win.Saola.stop)
        return;
    win.Saola.stop();
};
exports.stop = stop;
const customEvent = (eventType, data) => {
    if (!win.Saola || !win.Saola.customEvent)
        return;
    win.Saola.customEvent(eventType, data);
};
exports.customEvent = customEvent;
const setParams = (accountToken, customOptions = {}) => {
    win.SaolaParams = { token: accountToken, options: customOptions };
};
const injectSDK = (version) => {
    const SDKScript = win.document.createElement('script');
    SDKScript.defer = true;
    SDKScript.src = SDK_URL.replace(VERSION_PLACEHOLDER, version);
    win.document.head.appendChild(SDKScript);
};
//# sourceMappingURL=index.js.map